// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__F6Q1O","name":"styles_name__3drtH","phone":"styles_phone__23JZJ"};